export default {
  beforeMount( el, binding ) {
    el.clickOutsideEvent = function (ev) {
      if ( !(el == ev.target || el.contains(ev.target)) && document.body.contains(el) && document.body.contains(ev.target) ) {
        binding.value(ev, el)
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unmounted( el ) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  }
}